import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  keeper: 0,
  defending: 0,
  playmaking: 0,
  wing: 0,
  passing: 0,
  scoring: 0,
  setPieces: 0,
  country: 11,
}

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    changeKeeperFilter(state, action) {
      state = { ...state, keeper: action.payload }
      return state
    },
    changeDefendingFilter(state, action) {
      state = { ...state, defending: action.payload }
      return state
    },
    changePlaymakingFilter(state, action) {
      state = { ...state, playmaking: action.payload }
      return state
    },
    changePassingFilter(state, action) {
      state = { ...state, passing: action.payload }
      return state
    },
    changeWingFilter(state, action) {
      state = { ...state, wing: action.payload }
      return state
    },
    changeScoringFilter(state, action) {
      state = { ...state, scoring: action.payload }
      return state
    },
    changeSetPiecesFilter(state, action) {
      state = { ...state, setPieces: action.payload }
      return state
    },
    setFilter(state, action) {
      //console.log(action.payload)
      state = action.payload
      //console.log(state)
      return state
    },
    resetFilter() {
      return initialState
    },
  },
})

export const {
  setFilter,
  changeKeeperFilter,
  changeDefendingFilter,
  changePlaymakingFilter,
  changeWingFilter,
  changePassingFilter,
  changeScoringFilter,
  changeSetPiecesFilter,
  resetFilter,
} = filterSlice.actions

export const initializeFilter = () => {
  return dispatch => {
    const filter = initialState
    dispatch(setFilter(filter))
  }
}

export default filterSlice.reducer
